import type { TopologySnapshot } from '@/domain';
import type { StationId } from '@/domain/types';
import type { TopologyRepository } from '@/persistence/ports';
import type { Evse3Database } from '../db';

export class TopologyRepositoryDexie implements TopologyRepository {
  constructor(private readonly db: Evse3Database) {}

  async get(stationId: StationId): Promise<TopologySnapshot | null> {
    const row = await this.db.topologies.get(stationId);
    if (!row) return null;
    return { cpMaxPowerW: row.cpMaxPowerW, evses: row.evses };
  }

  async upsert(stationId: StationId, snap: TopologySnapshot): Promise<void> {
    await this.db.topologies.put({ stationId, ...snap });
  }

  async delete(stationId: StationId): Promise<void> {
    await this.db.topologies.delete(stationId);
  }
}
